/**
 * This is the JS file for the creation alert before creation account on mention.
 */

// Create alerts if the params exist
function createBeforeAlerts(tokenUser) {

	var idsAlerts = null;
	var beforeAlerts = localStorage.getItem('beforeAlerts');
	if (beforeAlerts)
		idsAlerts = beforeAlerts.split(',');

	console.log(idsAlerts);

  if (tokenUser && idsAlerts && idsAlerts.length > 0) {
    $.ajax({
      url: '/wp-content/themes/mention/scripts/wp-before-alerts.php',
      type: 'POST',
      data: { token: tokenUser, ids: idsAlerts },
      dataType: 'json',
      headers: {
        'accept': 'application/json'
      },
      success: function(dataResponse) {
        console.log('Before Alerts Success:');
        console.log(dataResponse);
      },
      error: function(xhr, status, error) {
        var obj = $.parseJSON(xhr.responseText);
        var errorMsg = obj.message;
        console.log('Before Alerts Error:');
        console.log(errorMsg);
      }
    });
    localStorage.removeItem('beforeAlerts');
  }
}
